"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationalSearchVideo = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@site/utils");
const ConversationalSearchVideo = ({
  webmVideoUrl,
  mp4VideoUrl,
  videoTitle,
  className
}) => /*#__PURE__*/_react.default.createElement("video", {
  preload: "auto",
  autoPlay: true,
  loop: true,
  muted: true,
  playsInline: true,
  title: videoTitle,
  className: className,
  "data-cy": className,
  "data-testid": className
}, /*#__PURE__*/_react.default.createElement("source", {
  "data-testid": `${className}-src-webm`,
  "data-cy": `${className}-src-webm`,
  src: webmVideoUrl,
  type: "video/webm"
}), (0, _utils.isSafariBrowser)() && /*#__PURE__*/_react.default.createElement("source", {
  "data-testid": `${className}-src-mp4`,
  "data-cy": `${className}-src-mp4`,
  src: mp4VideoUrl,
  type: "video/mp4"
}));
exports.ConversationalSearchVideo = ConversationalSearchVideo;
ConversationalSearchVideo.propTypes = {
  webmVideoUrl: _propTypes.default.string,
  mp4VideoUrl: _propTypes.default.string,
  videoTitle: _propTypes.default.string,
  className: _propTypes.default.string
};